import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { combineAll, DcBaseComponent } from '@datachain/ui-sdk/common';
import {
	AppModalService,
	ModalData,
} from '@datachain/ui-sdk/components/app-modal';
import {
	BehaviorSubject,
	distinctUntilChanged,
	map,
	Observable,
	takeUntil,
	tap,
} from 'rxjs';
import { DcIcons } from 'src/app/ui/app-dc.icons';

import { ProjectAdminEntity } from '../orphan-project-list/project-admin.entity';

export enum OrphanProjectAction {
	BulkMap = 'bulk-map',
	ConfirmSave = 'confirm-save',
}

export interface IOrphanProjectActionData {
	admins?: Array<ProjectAdminEntity>;
	action: OrphanProjectAction;
}

@Component({
	selector: 'app-orphan-project-action-popup',
	templateUrl: './orphan-project-action-popup.component.html',
	styleUrls: ['./orphan-project-action-popup.component.scss'],
})
export class OrphanProjectActionPopupComponent<
		T extends IOrphanProjectActionData
	>
	extends DcBaseComponent
	implements OnInit
{
	private readonly searchSubject = new BehaviorSubject<string>('');
	private readonly adminsSubject = new BehaviorSubject<
		Array<ProjectAdminEntity> | undefined
	>(this.modalData.admins ?? []);
	public readonly Icons = DcIcons;
	public vo$!: Observable<{
		action: OrphanProjectAction;
		admins: Array<ProjectAdminEntity> | undefined;
		searchInput: string;
	}>;
	public confirmDeletion = false;
	public selectedAdmin = '';
	public OrphanProjectAction = OrphanProjectAction;

	protected readonly DcIcons = DcIcons;
	public constructor(
		private readonly modalService: AppModalService,
		@Inject(MAT_DIALOG_DATA) public readonly modalData: ModalData & T
	) {
		super();
		this.cmpId = 'orphan-project-action';
	}

	public ngOnInit(): void {
		super.ngOnInit();
		this.vo$ = combineAll({
			action: this.modalData.action,
			admins: this.adminsSubject,
			searchInput: this.searchSubject,
		});

		this.searchSubject
			.pipe(
				takeUntil(this.onDestroy$),
				distinctUntilChanged(),
				map((searchTerm) =>
					this.modalData.admins?.filter((user) =>
						user.name.includes(searchTerm.toLowerCase())
					)
				),
				tap((admins) => this.adminsSubject.next(admins))
			)
			.subscribe();
	}

	public onSearchInputChange(input: string): void {
		this.searchSubject.next(input);
		if (!input) {
			this.selectedAdmin = '';
		}
	}

	public selected(id: string): void {
		this.selectedAdmin = id;
	}

	public confirmAction(): void {
		if (
			this.modalData.action === OrphanProjectAction.BulkMap &&
			!this.selectedAdmin
		) {
			return;
		}
		this.modalService.closeActiveModal({
			shouldLaunch: true,
			selectedAdmin:
				this.modalData.action === OrphanProjectAction.BulkMap
					? this.selectedAdmin
					: undefined,
		});
	}
}
